import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { Picture } from 'components/picture';

export const Container = styled.div`
  background-color: #fff;
  margin: 0 2rem;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${Styles.desktop} {
    width: 100%;
    padding: 0;
    margin: 0;
    justify-content: start;
    position: fixed;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  flex-shrink: 0;
  z-index: ${Styles.zIndex.below};
  border-start-start-radius: 20px;
  border-start-end-radius: 20px;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
`;

export const BackgroundImage = styled(Picture)`
  width: 100%;
  height: 100%;
  position: absolute;
`;

export const TextContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const OfferImage = styled(Picture)`
  object-fit: contain;
`;

export const OfferDescription = styled.p`
  font-size: 1rem;
  line-height: 1.25rem;
  margin-block-end: 1.25rem;
`;

export const MainTitle = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.5rem;
  line-height: 1.5rem;
  margin-block-end: 0;
`;

export const CTAButton = styled(ActionButton)`
  width: 100%;
  background-color: ${Styles.color.red};
`;

export const CloseButton = styled(ActionButton)`
  width: 100%;
  background-color: transparent;
  color: ${Styles.color.black};
  margin-block-start: 1rem;
  &:focus {
    border: none;
  }
`;
